// import { GeolocationRequest } from '../../interface/request/GeolocationRequest'
// import { GenericAPIResponse } from '../../interface/response/CommonResponse'
// import { GeolocationData } from '../../interface/response/GeolocationResponse'
import { apiService } from '../apiService'

export const geolocationApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getGeolocation: builder.query({
      query: (searchText: string) => {
        return {
          url: `/GeoLocation/GetGeoLocation`,
          params: { searchText: searchText },
        }
      },
      transformResponse: (response: { data: any }) => {
        return response?.data
      },
      providesTags: ['GeolocationList'],
    }),
  }),
})

export const { useLazyGetGeolocationQuery } = geolocationApiService
